import React from "react";

export const BDIFormQuestions = [
    {
        id: 1,
        title: "Sadness",
        options: [
            "I do not feel sad.",
            "I feel sad much of the time.",
            "I am sad all the time.",
            "I am so sad or unhappy that I can't stand it."
        ]
    },
    {
        id: 2,
        title: "Pessimism",
        options: [
            "I am not discouraged about my future.",
            "I feel more discouraged about my future than I used to.",
            "I do not expect things to work out for me.",
            "I feel my future is hopeless and will only get worse."
        ]
    },
    {
        id: 3,
        title: "Past Failure",
        options: [
            "I do not feel like a failure.",
            "I have failed more than I should have.",
            "As I look back, I see a lot of failures.",
            "I feel I am a total failure as a person."
        ]
    },
    {
        id: 4,
        title: "Loss of Pleasure",
        options: [
            "I get as much pleasure as I ever did from the things I enjoy.",
            "I don't enjoy things as much as I used to.",
            "I get very little pleasure from the things I used to enjoy.",
            "I can't get any pleasure from the things I used to enjoy."
        ]
    },
    {
        id: 5,
        title: "Guilty Feelings",
        options: [
            "I don't feel particularly guilty.",
            "I feel guilty over many things I have done or should have done.",
            "I feel quite guilty most of the time.",
            "I feel guilty all of the time."
        ]
    },
    {
        id: 6,
        title: "Punishment Feelings",
        options: [
            "I don't feel I am being punished.",
            "I feel I may be punished.",
            "I expect to be punished.",
            "I feel I am being punished."
        ]
    },
    {
        id: 7,
        title: "Self-Dislike",
        options: [
            "I feel the same about myself as ever.",
            "I have lost confidence in myself.",
            "I am disappointed in myself.",
            "I dislike myself."
        ]
    },
    {
        id: 8,
        title: "Self-Criticalness",
        options: [
            "I don't criticize or blame myself more than usual.",
            "I am more critical of myself than I used to be.",
            "I criticize myself for all of my faults.",
            "I blame myself for everything bad that happens."
        ]
    },
    {
        id: 9,
        title: "Suicidal Thoughts or Wishes",
        options: [
            "I don't have any thoughts of killing myself.",
            "I have thoughts of killing myself, but I would not carry them out.",
            "I would like to kill myself.",
            "I would kill myself if I had the chance."
        ]
    },
    {
        id: 10,
        title: "Crying",
        options: [
            "I don't cry anymore than I used to.",
            "I cry more than I used to.",
            "I cry over every little thing.",
            "I feel like crying, but I can't."
        ]
    },
    {
        id: 11,
        title: "Agitation",
        options: [
            "I am no more restless or wound up than usual.",
            "I feel more restless or wound up than usual.",
            "I am so restless or agitated, it's hard to stay still.",
            "I am so restless or agitated that I have to keep moving or doing something."
        ]
    },
    {
        id: 12,
        title: "Loss of Interest",
        options: [
            "I have not lost interest in other people or activities.",
            "I am less interested in other people or things than before.",
            "I have lost most of my interest in other people or things.",
            "It's hard to get interested in anything."
        ]
    },
    {
        id: 13,
        title: "Indecisiveness",
        options: [
            "I make decisions about as well as ever.",
            "I find it more difficult to make decisions than usual.",
            "I have much greater difficulty in making decisions than I used to.",
            "I have trouble making any decisions."
        ]
    },
    {
        id: 14,
        title: "Worthlessness",
        options: [
            "I do not feel I am worthless.",
            "I don't consider myself as worthwhile and useful as I used to.",
            "I feel more worthless as compared to others.",
            "I feel utterly worthless."
        ]
    },
    {
        id: 15,
        title: "Loss of Energy",
        options: [
            "I have as much energy as ever.",
            "I have less energy than I used to have.",
            "I don't have enough energy to do very much.",
            "I don't have enough energy to do anything."
        ]
    },
    {
        id: 16,
        title: "Changes in Sleeping Pattern",
        options: [
            "I have not experienced any change in my sleeping.",
            "I sleep somewhat more than usual. / I sleep somewhat less than usual.",
            "I sleep a lot more than usual. / I sleep a lot less than usual.",
            "I sleep most of the day. / I wake up 1-2 hours early and can't get back to sleep."
        ]
    },
    {
        id: 17,
        title: "Irritability",
        options: [
            "I am not more irritable than usual.",
            "I am more irritable than usual.",
            "I am much more irritable than usual.",
            "I am irritable all the time."
        ]
    },
    {
        id: 18,
        title: "Changes in Appetite",
        options: [
            "I have not experienced any change in my appetite.",
            "My appetite is somewhat less than usual. / My appetite is somewhat greater than usual.",
            "My appetite is much less than before. / My appetite is much greater than usual.",
            "I have no appetite at all. / I crave food all the time."
        ]
    },
    {
        id: 19,
        title: "Concentration Difficulty",
        options: [
            "I can concentrate as well as ever.",
            "I can't concentrate as well as usual.",
            "It's hard to keep my mind on anything for very long.",
            "I find I can't concentrate on anything."
        ]
    },
    {
        id: 20,
        title: "Tiredness or Fatigue",
        options: [
            "I am no more tired or fatigued than usual.",
            "I get more tired or fatigued more easily than usual.",
            "I am too tired or fatigued to do a lot of the things I used to do.",
            "I am too tired or fatigued to do most of the things I used to do."
        ]
    },
    {
        id: 21,
        title: "Loss of Interest in Sex",
        options: [
            "I have not noticed any recent change in my interest in sex.",
            "I am less interested in sex than I used to be.",
            "I am much less interested in sex now.",
            "I have lost interest in sex completely."
        ]
    }
]
const BDIForm = ({ formData, handleChange }) => {
    const questions = BDIFormQuestions;

    const calculateTotal = () => {
        return questions.reduce((sum, q) => sum + (parseInt(formData[`q${q.id}`] || 0, 10)), 0);
    };

    const totalScore = calculateTotal();

    const getLevel = (score) => {
        if (score <= 13) return { text: "Minimal depression", color: "success" };
        if (score <= 19) return { text: "Mild", color: "info" };
        if (score <= 28) return { text: "Moderate", color: "warning" };
        return { text: "Severe", color: "danger" };
    };

    const level = getLevel(totalScore);

    return (
        <>
            <div className="row mb-4 position-sticky top-0 bg-white pt-3" style={{ zIndex: 10 }}>
                <div className="col-md-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#bdiGuidelines"
                    >
                        <i className="ri-information-line me-2"></i>
                        Guidelines & Scoring
                    </button>
                </div>
            </div>
            <div className="p-3" style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                {/* Guidelines Button */}


                <div className="accordion" id="bdiAccordion">
                    {/* Client Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#clientInfo">
                                Client Information
                            </button>
                        </h2>
                        <div id="clientInfo" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="clientName"
                                                value={formData.clientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId} // ⭐ ADD THIS PROPERTY ⭐
                                            />
                                            <label>Client Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="diagnosis" value={formData.diagnosis || ""} onChange={handleChange} />
                                            <label>Diagnosis</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="assessedBy" value={formData.assessedBy || ""} onChange={handleChange} />
                                            <label>Assessed By</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Each Question in its own collapsible section */}
                    {questions.map((q, index) => (
                        <div className="accordion-item mb-3 shadow-sm rounded" key={q.id}>
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-medium text-dark d-flex justify-content-between align-items-center w-100"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#question${q.id}`}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="me-3 text-primary fw-bold">{q.id}.</span>
                                        <span className="flex-grow-1 text-start">{q.title}</span>
                                    </div>

                                    {/* {formData[`q${q.id}`] !== undefined && (
                                    <span className="badge bg-primary-subtle text-primary rounded-pill px-3">
                                        Score: {formData[`q${q.id}`]}
                                    </span>
                                )} */}
                                </button>
                            </h2>
                            <div id={`question${q.id}`} className="accordion-collapse collapse">
                                <div className="accordion-body pt-4">
                                    <div className="row g-4">
                                        {/* Always 4 options → 2 rows, 2 columns */}
                                        {q.options.map((option, idx) => (
                                            <div className="col-lg-6" key={idx}>
                                                <div className="form-check mb-3">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name={`q${q.id}`}
                                                        id={`q${q.id}_opt${idx}`}
                                                        value={idx}
                                                        checked={formData[`q${q.id}`] === String(idx)}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label fw-medium d-flex align-items-start" htmlFor={`q${q.id}_opt${idx}`}>
                                                        <span className="text-primary fw-bold me-3 flex-shrink-0">{idx}.</span>
                                                        <span>{option}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Total Score Section */}
                    <div className="mt-5 pt-4 border-top">
                        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-4">
                            Score Calculation
                        </small>
                        <div className="row g-3">
                            <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={totalScore}
                                        placeholder="Total"
                                        readOnly={true}
                                    />
                                    <label>Total Score</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Guidelines Modal */}
                <div className="modal fade" id="bdiGuidelines" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-body">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">About</small>
                                <p className="small">The BDI-II is a 21-item self-report inventory for measuring the severity of depression in adolescents and adults.</p>

                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">Instructions</small>
                                <p className="small">Read each group of statements carefully. Choose <strong>only one</strong> statement from each group that best describes how you have been feeling during the <strong>past two weeks, including today</strong>.</p>

                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">Scoring</small>
                                <p className="small mb-2">Each statement is scored 0–3. Total score = sum of all items.</p>
                                <ul className="small">
                                    <li><strong>0–13</strong> → Minimal depression</li>
                                    <li><strong>14–19</strong> → Mild depression</li>
                                    <li><strong>20–28</strong> → Moderate depression</li>
                                    <li><strong>29–63</strong> → Severe depression</li>
                                </ul>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BDIForm;